import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/infrastructures`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAllInfrastructures = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllInfrastructures`, {
      headers: authHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des infrastructures:", error);
    return [];
  }
};

export const createInfrastructure = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/addInfrastructure`, payload, {
      headers: authHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la création de l'infrastructure :",
      error.response || error
    );
    throw error;
  }
};

export const uploadImage = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage`, formData, {
      headers: {
        ...authHeaders(),
        "x-category": "infras",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image:", error);
    return null;
  }
};

export const updateInfrastructure = async (idOrInfrastructure, payload = null) => {
  try {
    const isTwoArgs = payload !== null;

    const infrastructureId = isTwoArgs
      ? idOrInfrastructure
      : idOrInfrastructure?.id;

    const body = isTwoArgs ? payload : idOrInfrastructure;

    if (!infrastructureId) {
      throw new Error("ID infrastructure manquant.");
    }

    const response = await axios.put(
      `${apiUrl}/updateInfrastructure/${infrastructureId}`,
      body,
      {
        headers: authHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour de l'infrastructure:",
      error.response?.data || error
    );
    throw error;
  }
};

export const deleteInfrastructure = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteInfrastructure/${id}`, {
      headers: authHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'infrastructure:", error);
    throw error;
  }
};